require("../../node_modules/bootstrap/dist/css/bootstrap.css");
require("../../node_modules/bootstrap-icons/font/bootstrap-icons.scss");

require("../../node_modules/bootstrap/dist/js/bootstrap.min.js");
require("material-icons");
